export const imgsapiUrl = "https://play.vqmjc.cc/static/";
// export const imgsapiUrl = 'http://192.168.50.18:8000/static/'
export const apiUrl = "https://play.vqmjc.cc/api/";
// export const apiUrl = 'http://192.168.50.18:8000/api/'
// export const leadUrl = "https://time2lead.leadportal.com/apiJSON.php";

export const leadUrl = "http://192.168.60.17:8000";
